"use client";
import { UserProvider as Auth0UserProvider } from "@auth0/nextjs-auth0/client";
import React from "react";

import { ContextProvider } from "@/context/context-provider";
import { SocketProvider } from "@/context/socket-context-provider";
import { UserProvider } from "@/context/user-context-provider";

const Provider = ({ children }) => {
    return (
        <Auth0UserProvider>
            <UserProvider>
                <ContextProvider>
                    <SocketProvider>{children}</SocketProvider>
                </ContextProvider>
            </UserProvider>
        </Auth0UserProvider>
    );
};

export default Provider;

import { createInstance } from "i18next";
import { I18nextProvider } from "react-i18next";

import initTranslations from "@/app/i18n";

export const TranslationsProvider = ({ children, locale, resources }) => {
    const i18n = createInstance();

    initTranslations(locale, i18n, resources);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
